import { dailySessionNotes } from '../../actions/constant';

const {
  GET_DAILY_NOTES_PRINT_STATUS_SUCCESS,
  GET_DAILY_NOTES_PRINT_STATUS_FAILURE,
  GET_DAILY_NOTES_PRINT_STATUS_LOADING,
  RESET_DAILY_NOTES_PRINT_STATUS,
} = dailySessionNotes;

const initialState: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDailyNotesPrintStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_DAILY_NOTES_PRINT_STATUS_SUCCESS:
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };

    case GET_DAILY_NOTES_PRINT_STATUS_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DAILY_NOTES_PRINT_STATUS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_DAILY_NOTES_PRINT_STATUS:
      return initialState;

    default:
      return state;
  }
};
